export const INVOICE_STATUS = {
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  PARTIALLY_COMPLETED: "PARTIALLY_COMPLETED",
  ACTION_REQUIRED: "ACTION_REQUIRED"
};

export const INVOICE_STATUS_OPTIONS = [
  { label: "Processing", value: INVOICE_STATUS.PROCESSING },
  { label: "Partially Completed", value: INVOICE_STATUS.PARTIALLY_COMPLETED },
  { label: "Action Required", value: INVOICE_STATUS.ACTION_REQUIRED },
  { label: "Completed", value: INVOICE_STATUS.COMPLETED }
];

export const PENDING_INVOICE_STATUSES = [
  INVOICE_STATUS.PROCESSING,
  INVOICE_STATUS.PARTIALLY_COMPLETED,
  INVOICE_STATUS.ACTION_REQUIRED
];

export const INVOICE_STATUS_PILL = {
  [INVOICE_STATUS.PROCESSING]: { title: "Processing", backGroundColor: "default", textColor: "#5B5B5B" },
  [INVOICE_STATUS.PARTIALLY_COMPLETED]: { title: "Partially Completed", backGroundColor: "gold", textColor: "#7a4e00" },
  [INVOICE_STATUS.ACTION_REQUIRED]: { title: "Action Required", backGroundColor: "red", textColor: "#a8071a" },
  [INVOICE_STATUS.COMPLETED]: { title: "Completed", backGroundColor: "green", textColor: "#135200" }
};

export const ITEM_STATUS = {
  PENDING_AUTO_ONBOARD: "PENDING_AUTO_ONBOARD",
  AUTO_ONBOARDED: "AUTO_ONBOARDED",
  MANUAL_ONBOARD_REQUIRED: "MANUAL_ONBOARD_REQUIRED",
  MANUAL_ONBOARDED: "MANUAL_ONBOARDED"
};

export const ITEM_STATUS_PILL = {
  [ITEM_STATUS.PENDING_AUTO_ONBOARD]: {
    title: "Pending Auto-Onboard",
    backGroundColor: "default",
    textColor: "#5B5B5B"
  },
  [ITEM_STATUS.AUTO_ONBOARDED]: { title: "Auto Onboarded", backGroundColor: "green", textColor: "#135200" },
  [ITEM_STATUS.MANUAL_ONBOARD_REQUIRED]: {
    title: "Manual Onboard Required",
    backGroundColor: "gold",
    textColor: "#7a4e00"
  },
  [ITEM_STATUS.MANUAL_ONBOARDED]: { title: "Manually Onboarded", backGroundColor: "green", textColor: "#135200" }
};

export const APPROVAL_STATUS = {
  PRIMARY_PENDING: "PRIMARY_PENDING",
  SECONDARY_PENDING: "SECONDARY_PENDING",
  SENT_BACK_TO_PRIMARY: "SENT_BACK_TO_PRIMARY",
  COMPLETED: "COMPLETED"
};

export const APPROVAL_STATUS_PILL = {
  [APPROVAL_STATUS.PRIMARY_PENDING]: { title: "Primary Pending", backGroundColor: "gold", textColor: "#7a4e00" },
  [APPROVAL_STATUS.SECONDARY_PENDING]: { title: "Secondary Pending", backGroundColor: "gold", textColor: "#7a4e00" },
  [APPROVAL_STATUS.SENT_BACK_TO_PRIMARY]: { title: "Sent Back", backGroundColor: "red", textColor: "#a8071a" },
  [APPROVAL_STATUS.COMPLETED]: { title: "Approved", backGroundColor: "green", textColor: "#135200" }
};

export const getApprovalStatusPill = (value) => {
  if (!value) return null;
  if (APPROVAL_STATUS_PILL[value]) return APPROVAL_STATUS_PILL[value];
  const v = String(value).toLowerCase();
  if (v.includes("completed")) return { title: value, backGroundColor: "green", textColor: "#135200" };
  if (v.includes("sent back")) return { title: value, backGroundColor: "red", textColor: "#a8071a" };
  if (v.includes("pending")) return { title: value, backGroundColor: "gold", textColor: "#7a4e00" };
  return { title: value, backGroundColor: "default", textColor: "#5B5B5B" };
};

export const ACTION_TYPE = {
  ONBOARD_VEHICLE: "ONBOARD_VEHICLE",
  EDIT_VEHICLE: "EDIT_VEHICLE",
  APPROVE: "APPROVE",
  SEND_BACK: "SEND_BACK"
};

export const DEFAULT_PAGE_SIZE = 20;

export const PAGE_SIZE_OPTIONS = [20, 40, 60];

export const SOURCE_TYPE_OPTIONS = [
  { label: "Auction", value: "AUCTION" },
  { label: "Wholesale", value: "WHOLESALE" },
  { label: "Partnership", value: "PARTNERSHIP" }
];

export const SALE_CHANNEL_OPTIONS = [
  { label: "Retail", value: "RETAIL" },
  { label: "Wholesale", value: "WHOLESALE" }
];
